<mat-toolbar class="main-footer">
    <div fxLayout="row" fxLayoutAlign="start" fxFlex>
        <!-- <a href="javascript:void(0)" mat-button class="pink" fxFlex="0 0 auto" fxLayout="row" fxLayoutAlign="start center">
             <mat-icon class="s-16 mr-sm-4">shopping_cart</mat-icon>
            <span>2018 - 2019 © Honeybee </span>
        </a> -->
        <span class="footer-hadding">2019 - {{actualYear}} © Syndifi </span>

        <div fxLayout="row" fxLayoutAlign="start center" fxHide fxShow.gt-xs>

            <!-- <a mat-button routerLink="/documentation/getting-started/introduction">Features</a>
            <span>&bull;</span>
            <a mat-button routerLink="/documentation/changelog">Write Us</a>
            <span>&bull;</span>
            <a mat-button routerLink="/documentation/getting-started/introduction">Chat</a> -->
        </div>
    </div>
</mat-toolbar>